import { AnalyticsGTM, IAnalytics } from '@quicktools/shared-components/services/analytics-gtm';
import { ConverterAnalyticsEventType } from '@quicktools/shared-components/services/converter-analytics';
import { GA4 } from 'react-ga4/types/ga4';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

const page_name = 'landing_page';

class Analytics extends AnalyticsGTM {
  constructor(public options: IAnalytics, ga4Instance: GA4) {
    super(options, ga4Instance);
  }

  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
    });
    this.hjEvent(action);
  }

  pageOpen() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }
}

const analytics = new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);

export default analytics;
